<script>
import mixin from '@/plans/mx/shopping-cart';
import { Title as titleKey } from './pre';
export default {
  mixins: [mixin],
  methods: {
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.mx_title(this.$t(titleKey), this.mx_price(plan))}
            {this.mx_discount(plan.plan_code)}
            <h2 class="opc-cart-item__text">{`${plan.cartInfo.selected_number} ${this.$t('billing.events.addon.hub_hosts')}`}</h2>
            {this.mx_cycle(plan.billing_cycle)}
            {this.mx_edit(plan)}
            {this.mx_remove(plan)}
          </div>
        );
      });
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>
